



























































































































































































































































































































































































































































import { CHAT_TYPE } from "@/resources/constants/chat";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { TYPES_MESSAGES } from "@/resources/constants/messages";
import { MessagesInterfaces } from "@/resources/interfaces/messagesInterfaces";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { i18n } from "@/resources/locales";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import moment from "moment";
import { mixins } from "vue-class-component";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MessageComponent from "@/app/components/chat/components/message.component.vue";
import UserValidator from "@/resources/mixins/userValidator";
import KProgress from "k-progress";
import { integer } from "aws-sdk/clients/cloudfront";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "chat-content-component",
  components: {
    MessageComponent,
    KProgress,
  },
})
export default class ChatContent extends mixins(
  NotificationEvent,
  UserValidator,
  Plans
) {
  @Prop({ default: false }) minimizeChat;
  MAX_LENGTH = 2048;
  SHOW_LENGTH = 1000;
  WARNING_LENGTH = 1848;
  PLAN = PLAN;
  text = "";
  isQuestion = false;
  loading = true;
  sendMessageDisabled = false;
  inScroll = false;
  textAreaOldHeight = 36;
  messageLength = 0;
  pendingMessage = 0;
  pendingScrollMessage = 0;
  search = "";
  option1 = false;
  option2 = false;
  showSearch = false;
  placeholder = i18n.t("labels.message");
  activeScrol = false;

  activeCountDown = false;
  count = 5;
  timerCountdown = null;

  CHAT_TYPE = CHAT_TYPE;
  MEETING_TYPE = MEETING_TYPE;
  openConfirmClearModal = false;

  idToday = null;
  idYesterday = null;
  idDays = [];

  textSize = 0;
  isTeams = false;

  activePollModal = false;
  optionsPoll = null;
  disableResponse = true;
  alreadyVote = false;

  activeConfirmCancelPoll = false;

  isSafari = false;

  idCheckBoxQuestion = "";
  mounted(): void {
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.$store.dispatch("ChatStore/setNextTokenAction", null);
    this.getPinnedMessages();
    this.setContentHeight();
    this.getMessagesInChat();
    const graphicClientContainer = document.getElementById(
      "GraphicClientContainer"
    );
    const observer = new ResizeObserver((entries) => {
      this.setContentHeight();
    });
    observer.observe(graphicClientContainer);
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.isTeams = space?.superSpace?.isTeams;
  }
  beforeUnmount() {
    const chatContent = document.getElementById("chat-content");
    chatContent.removeEventListener("scroll", (ev) => {
      // console.log(ev);
    });
  }
  get isMultiWebinar(): boolean {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    return (
      meetingType === MEETING_TYPE.WEBINAR &&
      space.superSpace.isMultiWebinarActivated
    );
  }
  get pinnedMessagesLength(): number {
    return this.$store.getters["ChatStore/getPinnedMessagesLength"];
  }
  get userChat() {
    return this.$store.getters["ChatStore/getUserChat"];
  }
  get meetingType(): string {
    return this.$store.getters["MeetingStore/getMeetingType"];
  }
  get chatTitle(): string {
    const chatType = this.$store.getters["ChatStore/getChatType"];
    return this.userChat
      ? this.userChat.user.name
      : chatType === CHAT_TYPE.SPACE
      ? "General"
      : this.getRoomName();
  }
  get chatType(): string {
    return this.$store.getters["ChatStore/getChatType"];
  }
  get roomId(): string | null {
    return CHAT_TYPE.ROOM
      ? this.$store.getters["MeetingStore/getRoomId"]
      : null;
  }
  get user(): SpaceUserInterface {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  get messages(): Array<MessagesInterfaces> | [] {
    const messages = this.$store.getters["ChatStore/getMessages"];
    if (!messages) return [];
    if (this.minimizeChat) {
      this.pendingMessage = messages.length - this.messageLength;
    }
    if (this.inScroll) {
      this.pendingScrollMessage = messages.length - this.messageLength;
    }
    return messages
      .sort((a, b) =>
        moment(a.CreatedTimestamp).diff(moment(b.CreatedTimestamp))
      )
      .filter((a) =>
        this.search !== ""
          ? a.Content.normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .includes(
                this.search
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
              )
          : a
      )
      .filter((a) => {
        if (this.option1 && this.option2)
          return a.Content.includes("/*?/") || a.Content.includes("/*>/");
        if (this.option1) return a.Content.includes("/*?/");
        if (this.option2) return a.Content.includes("/*>/");
        else return a;
      });
  }
  getRoomName(): string {
    let roomName = this.$store.getters["MeetingStore/getRoomName"];
    if (!roomName) roomName = this.$i18n.t("labels.chatNameDefault");
    return roomName;
  }

  @Watch("chatType")
  getPinnedMessages() {
    if (!this.activeOptionPlan(PLAN.PIN_MESSAGES)) return;
    const user = this.$store.getters["UserStore/getSpaceUser"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    const chatType = this.$store.getters["ChatStore/getChatType"];
    if (this.chatType !== CHAT_TYPE.ONE_TO_ONE) {
      this.$store.dispatch("ChatStore/getPinnedMessageAction", {
        id: user.id,
        spaceId: space.id,
        roomId: chatType === CHAT_TYPE.ROOM ? this.roomId : null,
        callback: () => {
          // do nothing
        },
      });
    }
  }

  @Watch("minimizeChat")
  @Watch("chatType")
  getMessagesInChat(): void {
    const chatType = this.$store.getters["ChatStore/getChatType"];
    const nextToken = this.$store.getters["ChatStore/getNextToken"];
    this.loading = true;
    switch (chatType) {
      case CHAT_TYPE.ONE_TO_ONE: {
        if (this.userChat) {
          let id = this.userChat?.superSpaceUser?.id
            ? this.userChat.superSpaceUser.id
            : this.userChat.id;
          this.$store.dispatch("ChatStore/getMessagesInChat", {
            userId: id,
            nextToken,
            callback: () => {
              const messages = this.$store.getters["ChatStore/getMessages"];
              if (messages) this.messageLength = messages.length;
              this.activeScrol = false;
              this.loading = false;
              this.activateScroll(nextToken);
            },
            callbackError: () => {
              this.activeScrol = false;
              this.loading = false;
            },
          });
        } else {
          this.activeScrol = false;
          this.loading = false;
        }
        break;
      }
      case CHAT_TYPE.ROOM: {
        const roomId = this.$store.getters["MeetingStore/getRoomId"];
        this.$store.dispatch("ChatStore/getMessagesInRoomChatAction", {
          roomId,
          nextToken,
          callback: () => {
            const messages = this.$store.getters["ChatStore/getMessages"];
            if (messages) this.messageLength = messages.length;
            this.activeScrol = false;
            this.loading = false;
            this.activateScroll(nextToken);
          },
          callbackError: () => {
            this.activeScrol = false;
            this.loading = false;
          },
        });
        break;
      }
      case CHAT_TYPE.SPACE: {
        const space = this.$store.getters["SpaceStore/getSpace"];
        this.$store.dispatch("ChatStore/getMessagesInSpaceChat", {
          spaceId: space.id,
          nextToken,
          callback: () => {
            const messages = this.$store.getters["ChatStore/getMessages"];
            if (messages) this.messageLength = messages.length;
            this.activeScrol = false;
            this.loading = false;
            this.activateScroll(nextToken);
          },
          callbackError: () => {
            this.activeScrol = false;
            this.loading = false;
          },
        });
        break;
      }
    }
  }
  getTextLength() {
    //this.setContentHeight();
    if (this.text.length > 0) {
      var surrogate = encodeURIComponent(this.text);
      var result = "";
      for (var i = 0; i < surrogate.length; ) {
        var character = surrogate[i];
        i += 1;
        if (character == "%") {
          var hex = surrogate.substring(i, (i += 2));
          if (hex) {
            result += String.fromCharCode(parseInt(hex, 16));
          }
        } else {
          result += character;
        }
      }
      this.textSize = result.length;
    } else {
      this.textSize = 0;
    }
  }
  async sendMessage(): Promise<void> {
    if (this.text.trim() !== "") {
      if (this.textSize > this.MAX_LENGTH) return;
      const chatType = this.$store.getters["ChatStore/getChatType"];
      if (this.activeCountDown) return;
      switch (chatType) {
        case CHAT_TYPE.ONE_TO_ONE: {
          const userChat = this.$store.getters["ChatStore/getUserChat"];
          let id = this.userChat?.superSpaceUser?.id
            ? userChat.superSpaceUser.id
            : userChat.id;
          await this.$store.dispatch("ChatStore/sendNewMessageAction", {
            userId: id,
            data: {
              chatMessage: this.text,
              chatMessageType: TYPES_MESSAGES.NORMAL,
            },
          });
          break;
        }
        case CHAT_TYPE.ROOM: {
          this.text += this.isQuestion ? "/*?/" : "";
          const roomId = this.$store.getters["MeetingStore/getRoomId"];
          const spaceUser: SpaceUserInterface =
            this.$store.getters["UserStore/getSpaceUser"];
          //TODO Comprobar permisos para poder escribir sin limite
          if (
            (this.meetingType == MEETING_TYPE.MEETING &&
              !this.isAdmin() &&
              !this.isAdminBySpaceUser(spaceUser) &&
              !this.isSuperSpaceOwner() &&
              !this.isSuperSpaceOwnerByUserSpace(spaceUser)) ||
            (this.meetingType === MEETING_TYPE.WEBINAR &&
              !this.isWebinarUser() &&
              !this.isMultiWebinarUser() &&
              !this.isAdmin() &&
              !this.isAdminBySpaceUser(spaceUser) &&
              !this.isSuperSpaceOwner() &&
              !this.isSuperSpaceOwnerByUserSpace(spaceUser))
          ) {
            this.placeholder = i18n.t("labels.messageDisabled");
            this.sendMessageDisabled = true;
            setTimeout(() => {
              this.placeholder = i18n.t("labels.message");
              this.sendMessageDisabled = false;
            }, 7000);
            this.activeCountDown = true;
            this.countdown();
          }
          ///////////////////////////////////////////////////
          await this.$store.dispatch("ChatStore/sendRoomMessageAction", {
            roomId,
            data: {
              chatMessage: this.text,
              chatMessageType: this.isQuestion
                ? TYPES_MESSAGES.QUESTION
                : TYPES_MESSAGES.NORMAL,
            },
          });
          break;
        }
        case CHAT_TYPE.SPACE: {
          if (!this.activeOptionPlan(PLAN.GENERAL_CHAT)) {
            return;
          }
          const space = this.$store.getters["SpaceStore/getSpace"];
          await this.$store.dispatch("ChatStore/sendSpaceMessageAction", {
            spaceId: space.id,
            data: {
              chatMessage: this.text,
              chatMessageType: TYPES_MESSAGES.NORMAL,
            },
          });
          break;
        }
      }
      this.text = "";
      this.textSize = 0;
    }
  }
  activateScroll(nextToken): void {
    const chatContent = document.getElementById("chat-content");
    const input = document.getElementById("input-message");
    chatContent.removeEventListener("scroll", (ev) => {
      // console.log(ev);
    });

    setTimeout(() => {
      input.focus();
      //this.resizeTextArea();
    }, 500);
    setTimeout(() => {
      if (!nextToken) chatContent.scrollTop = chatContent.scrollHeight * 1000;
      else chatContent.scrollTop = 2000;
    }, 50);
    setTimeout(() => {
      this.onScrollChat();
    }, 1000);
  }
  preventEnter(event): void {
    if (event.keyCode === 13) {
      if (!event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    }
    /* const textarea = document.getElementById("input-message");
    if (textarea.scrollTop != 0) {
      this.resizeTextArea();
    } */
  }
  resizeTextArea(): void {
    const textArea = document.getElementById("input-message");
    textArea.style.height = "auto";
    const newHeight =
      textArea.scrollHeight <= 116 ? textArea.scrollHeight : 116;
    if (this.textAreaOldHeight !== newHeight) {
      this.textAreaOldHeight = newHeight;
      textArea.style.height = newHeight + "px";
      this.setContentHeight();
    }
  }
  onScrollChat(): void {
    const chatContent = document.getElementById("chat-content");
    if (!chatContent) return;
    chatContent.addEventListener("scroll", (ev) => {
      const a = chatContent.scrollTop;
      const b = chatContent.scrollHeight - chatContent.clientHeight;
      if (chatContent.scrollHeight > chatContent.scrollTop + 600) {
        if (!this.inScroll) {
          const messages = this.$store.getters["ChatStore/getMessages"];
          if (messages) this.messageLength = messages.length;
          this.inScroll = true;
        }
      } else {
        this.pendingScrollMessage = 0;
        this.messageLength = 0;
        this.inScroll = false;
      }
      if (a / b === 0) {
        this.loading = true;
        const nextToken = this.$store.getters["ChatStore/getNextToken"];
        if (nextToken && !this.activeScrol) {
          this.activeScrol = true;
          this.getMessagesInChat();
        } else this.loading = false;
      }
    });
  }
  setContentHeight(): void {
    const chatContainer =
      document.getElementById("chat-container")?.clientHeight;
    if (!chatContainer) return;
    const chatContent = document.getElementById("chat-content");
    const chatHeader = document.getElementById("chat-header")?.clientHeight;
    const inputText = document.getElementById("input-text")?.clientHeight;
    const chatActions =
      document.getElementById("chat-inner-header")?.clientHeight;
    if (!chatContent || !chatHeader || !inputText || !chatActions) return;
    let activeQuestion = 0;
    if (
      this.meetingType === MEETING_TYPE.WEBINAR &&
      this.chatType === CHAT_TYPE.ROOM &&
      this.textSize >= this.SHOW_LENGTH
    ) {
      activeQuestion = 15;
    }
    chatContent.style.height =
      chatContainer -
      chatHeader -
      inputText -
      chatActions -
      activeQuestion +
      "px";
    chatContent.scrollTop = chatContent.scrollHeight * 1000;
  }
  scrollToBottom(): void {
    const chatContent = document.getElementById("chat-content");
    chatContent.scrollTop = chatContent.scrollHeight * 1000;
  }
  copyInClipBoard(): void {
    let text = "";
    for (const message of this.messages) {
      text += `\n${message.Sender.Name}\n${message.Content}\n${moment(
        message.CreatedTimestamp
      ).format(
        i18n.locale === "es" ? "DD/MM/YYYY, HH:mm" : "MM/DD/YYYY, HH:mm"
      )}
      `;
    }
    const cb = navigator.clipboard;
    cb.writeText(text).then(() =>
      this.onDefault("", this.$i18n.t("notifications.descriptions.chatCopied"))
    );
  }
  openSearch(): void {
    this.showSearch = !this.showSearch;
    this.option1 = false;
    this.option2 = false;
    this.search = "";
  }
  countdown(): void {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
    this.timerCountdown = setTimeout(() => {
      this.count--;
      if (this.count >= 0) this.countdown();
      else {
        this.activeCountDown = false;
        this.count = 5;
      }
    }, 1000);
  }
  clearChat() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("ChatStore/clearChatAction", {
      spaceId: space.id,
      callback: () => {
        document.getElementById("chat-content").innerHTML = "";
        this.openConfirmClearModal = false;
      },
      callbackError: () => {
        this.openConfirmClearModal = false;
      },
    });
  }
  checkSeparationChat(time: string, id: string): boolean {
    const date = moment(time);

    const today = moment().startOf("day");
    if (moment(date).isSame(today, "d")) {
      if (!this.idToday) this.idToday = id;
      return true;
    }

    const yesterday = moment().subtract(1, "days").startOf("day");
    if (moment(date).isSame(yesterday, "d")) {
      if (!this.idYesterday) this.idYesterday = id;
      return true;
    }

    const data = {
      id: id,
      date: moment(time).format("L"),
    };
    const i = this.idDays.findIndex((e) => e.date === moment(time).format("L"));
    if (i == -1) this.idDays.push(data);
    return true;
  }
  textSizeStyle() {
    if (this.textSize >= this.MAX_LENGTH) {
      return "textsize-max";
    }
    if (this.textSize >= this.WARNING_LENGTH) {
      return "textsize-warning";
    }
    return "";
  }
  get poll() {
    let poll = this.$store.getters["PollStore/getPoll"];
    if (poll == null) {
      this.activePollModal = false;
      this.optionsPoll = null;
      this.alreadyVote = false;
      this.disableResponse = true;
      this.activeConfirmCancelPoll = false;
      this.activeCheckBox();
    }
    return poll;
  }
  get pollTime() {
    let pollTime = this.$store.getters["PollStore/getPollTime"];
    if (pollTime >= 100) this.alreadyVote = true;
    return pollTime;
  }
  openPoll() {
    this.activePollModal = true;
    if (this.poll.hasUserVoted || this.alreadyVote) {
      this.disableCheckBox();
    } else {
      this.activeCheckBox();
    }
  }
  votePoll() {
    if (this.optionsPoll) {
      this.alreadyVote = true;
      this.$store.dispatch("PollStore/votePollAction", {
        pollOption: this.optionsPoll,
        callback: (response) => {
          this.disableCheckBox();
        },
        callbackError: (error) => {
          this.alreadyVote = false;
        },
      });
    }
  }
  getPercentage(votes: any): any {
    let countVotes = 0;
    this.poll.pollOptions.forEach((pollOption) => {
      countVotes = countVotes + pollOption.totalVotes;
    });
    let result = votes * (100 / countVotes);
    return result ? result.toFixed(1) : 0;
  }
  setCheckbox(checkbox: any): void {
    let vsCheckbox = document.getElementsByClassName("vs-checkbox");
    for (var i = 0, l = vsCheckbox.length; i < l; ++i) {
      let element = vsCheckbox[i] as HTMLInputElement;
      if (element.name == "questions") {
        this.idCheckBoxQuestion = element.id;
      } else if (element.id != checkbox.target.id) element.checked = false;
    }
    if (checkbox.target.checked) this.disableResponse = false;
    else this.disableResponse = true;
  }
  disableCheckBox() {
    let vsCheckbox = document.getElementsByClassName("vs-checkbox-con");
    let vsCheckboxLabel = document.getElementsByClassName("vs-checkbox-label");
    if (vsCheckbox.length <= 1) {
      setTimeout(() => {
        this.disableCheckBox();
      }, 100);
    }
    for (var i = 0, l = vsCheckbox.length; i < l; ++i) {
      let element = vsCheckbox[i] as HTMLInputElement;
      let skipCheckBox = element.querySelector("input");
      if (skipCheckBox.id != this.idCheckBoxQuestion)
        element.style.visibility = "hidden";
    }
    for (var i = 0, l = vsCheckboxLabel.length; i < l; ++i) {
      let element = vsCheckboxLabel[i] as HTMLInputElement;
      element.style.cursor = "auto";
    }
  }
  activeCheckBox() {
    let vsCheckbox = document.getElementsByClassName("vs-checkbox-con");
    if (vsCheckbox.length <= 0) {
      setTimeout(() => {
        this.activeCheckBox();
      }, 100);
    }
    for (var i = 0, l = vsCheckbox.length; i < l; ++i) {
      let element = vsCheckbox[i] as HTMLInputElement;
      element.style.visibility = "visible";
    }
  }
  confirmCancelPoll(): void {
    this.activeConfirmCancelPoll = true;
  }
  cancelPoll(): void {
    this.$store.dispatch("PollStore/cancelPollAction", {
      pollId: this.poll.id,
      callback: (response) => {
        this.activePollModal = false;
        this.activeConfirmCancelPoll = false;
      },
      callbackError: (error) => {},
    });
  }
  getWinner(totalVotes, pollOptions): boolean {
    let winner = {
      totalVotes: totalVotes,
    };
    pollOptions.forEach((element) => {
      if (element.totalVotes >= winner.totalVotes) {
        winner = element;
      }
    });
    return totalVotes == winner.totalVotes ? true : false;
  }
}
